import styled from "styled-components";

export const SocialMediaWrapper = styled.button`
  margin-top: 20px;
  margin-right: 5px;
  background-color: #0c1021;
  color: white;
  border: none;
  cursor: pointer;
`;
